export const setClarityCustomTags = (key: string, value: string | string[]) => {
  if (!window.clarity) return
  window.clarity('set', key, value)
}
